import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { formatError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Lock, Mail, ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (e) {
      setErr(formatError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="pastel-grain min-h-screen grid place-items-center px-4 py-12">
      <div data-testid="login-card"
        className="w-full max-w-md brutal-border brutal-shadow rounded-2xl p-8 bg-white fade-up">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500">Welcome back</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mt-1">Log in</h1>
        <p className="text-zinc-600 mt-2 font-medium">Join the conversation again.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase font-bold tracking-widest">Email</label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
              <Input data-testid="login-email-input" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required
                className="pl-10 h-11 brutal-border rounded-xl bg-white font-medium focus-visible:ring-0 focus-visible:border-[var(--ink)]" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest">Password</label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
              <Input data-testid="login-password-input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} required
                className="pl-10 h-11 brutal-border rounded-xl bg-white font-medium focus-visible:ring-0 focus-visible:border-[var(--ink)]" />
            </div>
          </div>
          {err && (
            <div data-testid="login-error" className="text-sm font-bold text-[var(--destructive)] brutal-border rounded-lg p-2 bg-red-50">
              {err}
            </div>
          )}
          <Button type="submit" data-testid="login-submit-btn" disabled={loading}
            className="w-full h-12 brutal-border brutal-shadow rounded-xl font-bold text-base gap-2"
            style={{ background: "var(--primary)", color: "var(--ink)" }}>
            {loading ? "Logging in..." : <>Log in <ArrowRight size={18} /></>}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm font-medium text-zinc-600">
          New here?{" "}
          <Link to="/register" data-testid="login-register-link" className="font-bold underline">Create account</Link>
        </div>
      </div>
    </div>
  );
}
